import { render, staticRenderFns } from "./BlockMapInput.vue?vue&type=template&id=108c56ad&scoped=true&"
import script from "./BlockMapInput.vue?vue&type=script&lang=js&"
export * from "./BlockMapInput.vue?vue&type=script&lang=js&"
import style0 from "./BlockMapInput.vue?vue&type=style&index=0&lang=css&"
import style1 from "./BlockMapInput.vue?vue&type=style&index=1&id=108c56ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108c56ad",
  null
  
)

export default component.exports